import { useContext } from "react";
import { ThemeContext } from "../ThemeContext";

export default function Dashboard() {
  const theme = useContext(ThemeContext);
  return (
    <div style={{ padding: 20, color: theme.text }}>
      <h2>Dashboard</h2>
      <p>Manage your dashboard here.</p>
    </div>
  );
}
